import React from 'react';

const ExpressIcon = ({ fillColor, width = "55", height = "55", ...props }) => (
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 225.000000 225.000000"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <g
      transform="translate(0.000000,225.000000) scale(0.100000,-0.100000)"
      fill={fillColor}
      stroke="none"
    >
      <path
        d="M990 2209 c-423 -49 -793 -365 -914 -783 -70 -241 -50 -523 53 -751
80 -176 234 -355 393 -459 160 -104 309 -157 497 -177 519 -54 1009 279 1156
786 109 378 2 792 -279 1071 -180 179 -401 286 -649 313 -108 12 -149 12 -257
0z m-563 -904 c31 -21 50 -53 58 -97 l7 -38 -121 0 c-76 0 -121 -4 -121 -10 0
-21 31 -83 48 -96 9 -7 38 -14 63 -14 47 0 77 21 92 63 7 18 27 24 27 7 0 -28
-35 -73 -65 -86 -100 -41 -185 21 -185 134 0 83 34 138 95 155 28 8 75 -1 102
-18z m538 11 c50 -21 75 -68 75 -141 0 -72 -14 -102 -60 -133 -44 -30 -109
-26 -146 9 l-24 22 0 -76 c0 -62 -3 -77 -15 -77 -13 0 -15 29 -15 200 0 171 2
200 15 200 10 0 15 -10 15 -27 1 -25 2 -26 11 -10 12 20 63 46 92 47 10 0 33
-6 52 -14z m465 -14 c28 -21 45 -51 55 -99 l7 -33 -121 0 c-134 0 -134 0 -107
-65 17 -41 42 -55 96 -55 41 0 69 19 96 66 20 33 29 6 11 -32 -19 -38 -65 -64
-115 -64 -35 0 -92 37 -109 70 -20 40 -16 137 7 175 39 63 121 80 180 37z
m286 -5 c30 -30 40 -67 20 -67 -9 0 -16 7 -16 15 0 30 -38 55 -83 55 -56 0
-80 -17 -75 -55 3 -31 16 -38 115 -64 23 -6 49 -18 58 -27 17 -17 20 -66 5
-94 -11 -21 -60 -40 -102 -40 -55 0 -118 49 -118 92 0 23 19 23 27 1 3 -10 15
-28 26 -40 38 -43 157 -23 157 26 0 33 -26 53 -91 68 -73 16 -109 44 -109 83
0 28 32 65 65 73 37 10 100 -3 121 -26z m270 0 c30 -30 40 -67 20 -67 -9 0
-16 7 -16 15 0 30 -38 55 -83 55 -56 0 -80 -17 -75 -55 3 -31 16 -38 115 -64
23 -6 49 -18 58 -27 17 -17 20 -66 5 -94 -11 -21 -60 -40 -102 -40 -55 0 -118
49 -118 92 0 23 19 23 27 1 3 -10 15 -28 26 -40 38 -43 157 -23 157 26 0 33
-26 53 -91 68 -73 16 -109 44 -109 83 0 28 32 65 65 73 37 10 100 -3 121 -26z
m-1407 -38 l43 -60 45 61 c25 33 51 60 59 60 18 0 15 -6 -44 -83 l-44 -56 48
-63 c26 -35 52 -69 57 -75 7 -9 5 -13 -7 -13 -9 0 -37 28 -62 63 -25 34 -47
64 -49 66 -2 1 -25 -27 -51 -63 -26 -36 -54 -66 -61 -66 -20 0 -17 5 37 77 28
36 50 70 50 75 0 5 -23 38 -51 73 -40 51 -47 65 -32 65 10 0 36 -25 62 -61z
m541 41 c0 -20 0 -20 33 0 33 20 77 27 77 12 0 -5 -18 -14 -39 -20 -60 -18
-71 -44 -71 -162 0 -82 -3 -100 -15 -100 -13 0 -15 23 -15 145 0 122 2 145 15
145 8 0 15 -9 15 -20z"
      />
      <path
        d="M295 1278 c-14 -13 -29 -38 -34 -55 l-10 -33 105 0 c87 0 104 2 104
15 0 25 -28 73 -49 85 -34 18 -88 12 -116 -12z"
      />
      <path
        d="M845 1276 c-44 -44 -46 -157 -4 -202 33 -35 110 -34 144 2 48 52 41
162 -12 204 -37 29 -97 27 -128 -4z"
      />
      <path
        d="M1301 1284 c-19 -14 -51 -69 -51 -89 0 -3 47 -5 105 -5 66 0 105 4
105 10 0 24 -30 79 -48 89 -30 16 -84 13 -111 -5z"
      />
    </g>
  </svg>
);

export default ExpressIcon;